import { render, staticRenderFns } from "./QueryChocostickH.vue?vue&type=template&id=55a6b32c&"
import script from "./QueryChocostickH.vue?vue&type=script&lang=js&"
export * from "./QueryChocostickH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports